import { Routes } from '@angular/router';

export const adsVideosSettingsChildRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        loadComponent: () => import('./components/ad-overview/ad-overview.component').then((m) => m.AdOverviewComponent),
      },
      {
        path: 'videos-presence',
        loadComponent: () =>
          import('./components/ads-settings/ad-video-presence/ad-video-presence.component').then((m) => m.AdVideoPresenceComponent),
      },
      {
        path: 'statistics',
        loadComponent: () => import('./components/ads-settings/ad-statistics/ad-statistics.component').then((m) => m.AdStatisticsComponent),
      },
    ],
  },
];
